import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonFilterComponent } from '../common-filter/common-filter.component';
import { CheckboxFilterComponent } from "../../checkbox-filter/checkbox-filter.component";

@Component({
  standalone: true,
    selector: 'color-filter',
    templateUrl: './color-filter.component.html',
    styleUrls: ['./color-filter.component.scss'],
    imports: [CommonModule, CheckboxFilterComponent]
})
export class ColorFilterComponent extends CommonFilterComponent {

}

